import React from "react";
import { Grid, Paper, Box } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

import RpAlert from "@/components/alerts/RpAlert";
import { rrdDirectMailCampaignHelper } from "../utils/rrdDirectMailHelper";
import JoinCampaignLocationName from "@/features/campaigns/components/joinCampaignCommon/JoinCampaignLocationName";

type RRDNotEligibleLocationsProps = {
  locations?: Record<string, any>[];
};

const NotEligibleIcon = ErrorIcon as React.ElementType;

function RRDNotEligibleLocations({
  locations = [],
}: RRDNotEligibleLocationsProps) {
  if (!locations?.length) {
    return (
      <Box sx={{ p: 2, mt: 20, display: "flex", justifyContent: "center" }}>
        <RpAlert severity="info">There are no Not Eligible Locations</RpAlert>
      </Box>
    );
  }

  return (
    <div>
      {locations?.map((location) => (
        <Paper key={location?.id} sx={{ p: 1, mt: 1 }} elevation={2}>
          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid>
              <JoinCampaignLocationName>
                <NotEligibleIcon
                  color="error"
                  className="mr-1"
                  title="Not Eligible"
                />
                {rrdDirectMailCampaignHelper.getLocationName(location)}
              </JoinCampaignLocationName>
            </Grid>
            <Grid>
              <Box
                sx={{
                  textAlign: "right",
                }}
              >
                <RpAlert severity="warning">
                  {location.eligibility_reason}
                </RpAlert>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      ))}
    </div>
  );
}

export default RRDNotEligibleLocations;
